/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_Financialcriteriadescription22Inputs */

const en_welcome_accreditation_financialcriteriadescription22 = /** @type {(inputs: Welcome_Accreditation_Financialcriteriadescription22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Income over $200,000 (individually) or $300,000 (with spouse or partner) in each of the prior two years, and reasonably expects the same for the current year`)
};

/**
* | output |
* | --- |
* | "Income over $200,000 (individually) or $300,000 (with spouse or partner) in each of the prior two years, and reasonably expects the same for the current year" |
*
* @param {Welcome_Accreditation_Financialcriteriadescription22Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_accreditation_financialcriteriadescription22 = /** @type {((inputs?: Welcome_Accreditation_Financialcriteriadescription22Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_Financialcriteriadescription22Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_financialcriteriadescription22(inputs)
});
export { welcome_accreditation_financialcriteriadescription22 as "welcome_accreditation_financialCriteriaDescription2" }